import { useEffect } from "react";

interface UseOnMountUnmountProps {
  onMount?: () => void;
  onUnmount?: () => void;
}
export default function useOnMountUnmount(obj: UseOnMountUnmountProps) {
  useEffect(() => {
    obj.onMount?.();
    return () => obj.onUnmount?.();
  }, []);
}
